export default {
   items: [
      {
         title: true,
         name: "",
         wrapper: {
            // optional wrapper object
            element: "", // required valid HTML5 element tag
            attributes: {} // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
         },
         class: "" // optional class names space delimited list for title item ex: "text-center"
      },
      {
         name: "Dashboard",
         url: "/dashboard",
         icon: "icon-home"
      },
      {
         name: "View Members",
         url: "/employees",
         icon: "cui-magnifying-glass"
      },
      // {
      //    name: "Request eLOG",
      //    url: "/log/request",
      //    icon: "icon-envelope",
      // },
      {
         name: "eLOG Records",
         url: "/log/list",
         icon: "icon-docs",
         badge: {
            variant: "danger",
            text: "0"
         }
      },
      {
         name: "Pre-signed eLOG",
         url: "/log/pre-signed/list",
         icon: "icon-docs",
      },
      {
         name: "Find Panel Clinic",
         url: "/panel-clinic",
         icon: "icon-location-pin"
      },
      {
         name: "Analytics",
         url: "/mhc-insight",
         icon: "icon-pie-chart"
      },
      {
         name: "Claims Report",
         url: "/mhc-insight-report",
         icon: "icon-doc"
      },
      {
         name: "Add Partner/HR",
         url: "/add-partner-hr",
         icon: "cui-user-follow"
      },
      {
         name: "Manage Partner/HR",
         url: "/account/list",
         icon: "icon-people"
      },
      {
         name: "Account Logs",
         url: "/account/log/list",
         icon: "icon-doc"
      },
      {
         name: "Contact Us",
         url: "/contact-us",
         icon: "cui-envelope-closed"
      },
      {
         name: "Logout",
         url: "/logout",
         icon: "cui-account-logout"
      }
   ]
};
